import {Injectable} from '@angular/core';
import {StatusEventSignalDisplayDetails} from '@models/machine/status-event-signal/status-event-signal-display-details';
import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';
import {StatusEventTypeDescription} from '@constants/machine/status-event-signal/status-event-type-description';
import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';

@Injectable({
  providedIn: 'root'
})
export class StatusEventSignalDataHelperService {

  public tryParseJSONObject(inputString): any | null {
    if (!inputString || inputString.isNullOrWhitespace()) {
      return null;
    }

    try {
      const o = JSON.parse(inputString);
      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object",
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === 'object') {
        return o;
      }
    } catch (e) {
      return null;
    }

    return null;
  }


  public getEnhancedValue(language: string, object: any): string {
    const lineSeparator: string = ',<br/>';
    const statusEventSignalDisplayDetails: StatusEventSignalDisplayDetails = this.convertStringToStatusEventSignalDisplayDetails(object);
    let result: string = '';
    for (const detail of statusEventSignalDisplayDetails.values) {
      result += this.getStatusEventTypeIcon(detail) + detail.code + ' - ' + this.getLocalizedDisplayDescriptionOrDefault(language, detail) + lineSeparator;
    }
    result = result.slice(0, -1 * lineSeparator.length);
    return result;
  }

  private convertStringToStatusEventSignalDisplayDetails(object: any): StatusEventSignalDisplayDetails {

    const result: StatusEventDetails[] = [];
    if (!object || !object.originalValue || !object.values) {
      return new StatusEventSignalDisplayDetails('', []);
    }

    const values = object.values;
    const keys = Object.keys(values);
    for (const key of keys) {
      const objectElement = values[key];
      const item: StatusEventDetails = new StatusEventDetails(objectElement.code, objectElement.type, objectElement.description, new Map<string, string>(), objectElement.localizations);
      result.push(item);
    }


    return new StatusEventSignalDisplayDetails(object.o, result);
  }

  private getStatusEventTypeIcon(statusEventDetails: StatusEventDetails): string {
    if (!statusEventDetails || !statusEventDetails.type) {
      return '';
    }

    let icon: string = '';
    let row: string = '';
    const type: string = statusEventDetails.type;
    switch (statusEventDetails.type) {
      case StatusEventType.FAILURE:
        icon = 'fa-triangle-exclamation';
        row = StatusEventTypeDescription.FAILURE;
        break;
      case StatusEventType.WARNING:
        icon = 'fa-circle-exclamation';
        row = StatusEventTypeDescription.WARNING;
        break;
      case StatusEventType.INFO:
        icon = 'fa-circle-info';
        row = StatusEventTypeDescription.INFO;
        break;
      case StatusEventType.DEBUG:
        icon = 'fa-ban';
        row = StatusEventTypeDescription.DEBUG;
        break;
      case StatusEventType.INHIBIT:
        icon = 'fa-gear';
        row = StatusEventTypeDescription.INHIBIT;
        break;

    }
    return '<span class="widget-row-' + row + '"><span  class="status-icon-sm text-' + type + '"><i class="fa mr-2 ' + icon + '"></i></span></span>';
  }

  private getLocalizedDisplayDescriptionOrDefault(language: string, item: StatusEventDetails): string {

    if (!item) {
      return '';
    }
    let defaultDescription = '';

    if (item.description && !item.description.isNullOrWhitespace()) {
      defaultDescription = item.description;
    }


    if (language.isNullOrWhitespace()) {
      return defaultDescription;
    }

    const localizations = item.localizations;
    if (!localizations) {
      return defaultDescription;
    }

    const description = localizations[language];
    if (!description || description.isNullOrWhitespace()) {
      return defaultDescription;
    }
    return description;

  }

}
